<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useOperatingProceduresStore } from 'dashboard/stores/operatingProcedures';
import BaseNode from './BaseNode.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const store = useOperatingProceduresStore();

const referencedSop = computed(() =>
  store.getById(props.data.operating_procedure_id)
);
</script>

<template>
  <BaseNode
    :node-id="props.id"
    :selected="selected"
    icon="i-lucide-corner-down-right"
    :type-label="t('SOPS.NODES.REFERENCE')"
    :node-label="data.label"
    accent-class="bg-n-teal-9/15 text-n-teal-11"
  >
    <div class="border-t border-n-weak p-3">
      <p
        v-if="referencedSop"
        class="mb-0 flex items-start gap-1.5 text-sm text-n-slate-11"
      >
        <span class="i-lucide-workflow mt-0.5 size-3.5 shrink-0" />
        <span class="min-w-0 break-words">{{ referencedSop.name }}</span>
      </p>
      <p v-else class="mb-0 flex items-center gap-1 text-xs text-n-amber-11">
        <span class="i-lucide-triangle-alert size-3" />
        {{ t('SOPS.BUILDER.PANEL.NOT_CONFIGURED') }}
      </p>
    </div>
  </BaseNode>
</template>
